import { restRequest } from 'common-src/features/rest/actions';
import { HttpMethods } from 'common-src/features/rest/constants';

export const getDashboardV2ReadinessRequest = (query, params) =>
  restRequest({
    uri: '../v2/dashboard/readiness',
    query,
    method: HttpMethods.Get,
    ...params,
  });
